import { render } from "./Privacy.vue?vue&type=template&id=61c7e2ba&scoped=true&ts=true"
import script from "./Privacy.ts?vue&type=script&lang=ts&external"
export * from "./Privacy.ts?vue&type=script&lang=ts&external"

import "./Privacy.vue?vue&type=style&index=0&id=61c7e2ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c7e2ba"]])

export default __exports__